export default __webpack_public_path__ + "202343fcaeb690726de46ebde517740b.jpg";